export const FETCH_ORGANISATION = 'FETCH_ORGANISATION';
export const FETCH_POS = 'FETCH_POS';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const FETCH_PRODUCT = 'FETCH_PRODUCT';
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_ONGOING = 'FETCH_ONGOING';
export const FETCH_PLOTS = 'FETCH_PLOTS';
export const FETCH_RECEIPT = 'FETCH_RECEIPT';
export const CREATE_ORDER = 'CREATE_ORDER';
